module.exports = __webpack_public_path__ + "img/V41.790f2d5e.jpg";